import ReusableSection from "../../components/common/ReusableSection";

const testimonialData = {
  header: {
    title: "Hear Directly From our Farmers",
    description:
      "Farmers trust our organic fertilizers for improving soil health, increasing crop yield, and enhancing long-term farm sustainability. Their continued confidence and positive field results stand as a strong testimonial to the quality produced by UTPANN.",
    button: {
      text: "Watch More",
      onClick: () =>
        window.open(
          "https://www.youtube.com/@UTPANNOrganicFertilizer",
          "_blank",
        ),
    },
  },
  slides: [
    {
      // https://www.youtube.com/watch?v=hswy2WMTOtU&t=9s
      videoUrl: "https://www.youtube.com/watch?v=hswy2WMTOtU&t=1s",
      alt: "Farmer Testimonial 1",
    },
    {
      // https://www.youtube.com/watch?v=xafE2B4gQZc
      videoUrl: "https://www.youtube.com/watch?v=xafE2B4gQZc&t=2s",
      alt: "Farmer Testimonial 2",
    },
    {
      // https://www.youtube.com/watch?v=a-pHLp5JEfE
      videoUrl: "https://www.youtube.com/watch?v=a-pHLp5JEfE&t=10s",
      alt: "Farmer Testimonial 3",
    },
    {
      // https://www.youtube.com/watch?v=XbBmsnCSPHU
      videoUrl: "https://www.youtube.com/watch?v=XbBmsnCSPHU",
      alt: "Farmer Testimonial 4",
    },
    {
      // https://www.youtube.com/watch?v=hswy2WMTOtU&t=9s
      videoUrl: "https://www.youtube.com/watch?v=aHCiI1qs-o8",
      alt: "Farmer Testimonial 1",
    },
    {
      // https://www.youtube.com/watch?v=xafE2B4gQZc
      videoUrl: "https://www.youtube.com/watch?v=aaCalkO9tmk",
      alt: "Farmer Testimonial 2",
    },
    {
      // https://www.youtube.com/watch?v=a-pHLp5JEfE
      videoUrl: "https://www.youtube.com/watch?v=9AL6Km6rcX0&t=4s",
      alt: "Farmer Testimonial 3",
    },
    {
      // https://www.youtube.com/watch?v=XbBmsnCSPHU
      videoUrl: "https://www.youtube.com/watch?v=AV6ogV4C4Os",
      alt: "Farmer Testimonial 4",
    },
    {
      // https://www.youtube.com/watch?v=hswy2WMTOtU&t=9s
      videoUrl: "https://www.youtube.com/watch?v=6G67zoX_tII",
      alt: "Farmer Testimonial 1",
    },
    {
      // https://www.youtube.com/watch?v=xafE2B4gQZc
      videoUrl: "https://www.youtube.com/watch?v=_RUNnjSDocI",
      alt: "Farmer Testimonial 2",
    },
  ],
};

const TestimonialPage = () => {
  return (
    <main>
      <ReusableSection
        header={testimonialData.header}
        slides={testimonialData.slides}
      />
    </main>
  );
};

export default TestimonialPage;
